import { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { hablar, precargarMapaAudios } from '../utils/audioHelper'

const API = process.env.REACT_APP_API_URL

const PREGUNTAS = [
  {
    id: 'l1', habilidad: 'listening', nivel: 'A1',
    tipo: 'audio_opcion',
    instruccion: 'Listen to the description and choose the correct answer.',
    audio_texto: 'Hola, me llamo María. Tengo veinte años y soy de Colombia.',
    pregunta: 'What is the name of the person speaking?',
    opciones: ['Carlos', 'María', 'Ana', 'José'],
    correcta: 1
  },
  {
    id: 'l2', habilidad: 'listening', nivel: 'A2',
    tipo: 'audio_opcion',
    instruccion: 'Listen and choose the correct answer.',
    audio_texto: 'El restaurante abre a las doce del mediodía y cierra a las diez de la noche. Los domingos está cerrado.',
    pregunta: 'What time does the restaurant open?',
    opciones: ['10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM'],
    correcta: 2
  },
  {
    id: 'l3', habilidad: 'listening', nivel: 'B1',
    tipo: 'audio_opcion',
    instruccion: 'Listen to the conversation and answer.',
    audio_texto: 'Buenos días, quisiera reservar una mesa para cuatro personas el sábado por la noche. Tenemos disponibilidad a las ocho y media o a las diez. Prefiero a las ocho y media, por favor.',
    pregunta: 'What time was the reservation made for?',
    opciones: ['7:00 PM', '8:00 PM', '8:30 PM', '10:00 PM'],
    correcta: 2
  },
  {
    id: 'l4', habilidad: 'listening', nivel: 'B2',
    tipo: 'audio_opcion',
    instruccion: 'Listen carefully and choose the best answer.',
    audio_texto: 'El cambio climático es uno de los desafíos más importantes de nuestra época. Los científicos advierten que si no tomamos medidas urgentes, las consecuencias serán irreversibles para las próximas generaciones.',
    pregunta: 'What is the main message of this statement?',
    opciones: [
      'Climate change is not a real problem',
      'Scientists disagree about climate change',
      'Urgent action is needed to prevent irreversible consequences',
      'Future generations will solve climate change'
    ],
    correcta: 2
  },
  {
    id: 'l5', habilidad: 'listening', nivel: 'C1',
    tipo: 'audio_opcion',
    instruccion: 'Listen to the academic excerpt and answer.',
    audio_texto: 'La globalización ha transformado profundamente las estructuras económicas y sociales. Si bien ha facilitado el intercambio cultural y comercial, también ha generado desigualdades significativas entre naciones desarrolladas y en vías de desarrollo.',
    pregunta: 'What does the speaker suggest about globalization?',
    opciones: [
      'It has only positive effects on society',
      'It has both benefits and drawbacks',
      'It should be completely stopped',
      'It only affects developed countries'
    ],
    correcta: 1
  },
  {
    id: 'r1', habilidad: 'reading', nivel: 'A1',
    tipo: 'texto_opcion',
    instruccion: 'Read the text and answer the question.',
    texto: 'Me llamo Pedro. Tengo 25 años. Soy médico. Vivo en Bogotá con mi familia. Me gusta el fútbol y la música.',
    pregunta: 'What is Pedro profession?',
    opciones: ['Teacher', 'Engineer', 'Doctor', 'Lawyer'],
    correcta: 2
  },
  {
    id: 'r2', habilidad: 'reading', nivel: 'A2',
    tipo: 'texto_opcion',
    instruccion: 'Read and choose the correct answer.',
    texto: 'El Museo Nacional de Colombia fue fundado en 1823. Es el museo más antiguo del país y está ubicado en el centro de Bogotá. Tiene más de 20,000 piezas en su colección permanente.',
    pregunta: 'When was the National Museum of Colombia founded?',
    opciones: ['1800', '1823', '1850', '1900'],
    correcta: 1
  },
  {
    id: 'r3', habilidad: 'reading', nivel: 'B1',
    tipo: 'texto_opcion',
    instruccion: 'Read the text carefully and answer.',
    texto: 'El ajiaco es una sopa tradicional bogotana que se prepara con tres tipos de papa, pollo, mazorca y guascas. Este plato tiene sus orígenes en la cocina indígena muisca y se ha convertido en uno de los símbolos gastronómicos de la capital colombiana.',
    pregunta: 'What is the indigenous origin of ajiaco?',
    opciones: ['Aztec cuisine', 'Muisca cuisine', 'Inca cuisine', 'Taino cuisine'],
    correcta: 1
  },
  {
    id: 'r4', habilidad: 'reading', nivel: 'B2',
    tipo: 'texto_opcion',
    instruccion: 'Read the following text and answer.',
    texto: 'La biodiversidad de Colombia es extraordinaria. El país alberga aproximadamente el 10% de todas las especies del planeta en solo el 0.77% de la superficie terrestre. Esta riqueza biológica se debe principalmente a su posición geográfica estratégica, que combina ecosistemas tropicales, andinos, amazónicos y costeros.',
    pregunta: 'Why does Colombia have such extraordinary biodiversity?',
    opciones: [
      'Because it is the largest country in South America',
      'Due to its strategic geographic position combining multiple ecosystems',
      'Because of its large population',
      'Due to government conservation policies'
    ],
    correcta: 1
  },
  {
    id: 'r5', habilidad: 'reading', nivel: 'C1',
    tipo: 'texto_opcion',
    instruccion: 'Read this academic text and choose the best interpretation.',
    texto: 'El realismo mágico, corriente literaria latinoamericana que alcanza su apogeo con Gabriel García Márquez, no constituye meramente una técnica narrativa, sino una cosmovisión que integra lo cotidiano y lo extraordinario como dimensiones complementarias de la realidad.',
    pregunta: 'According to the text, magical realism is best described as:',
    opciones: [
      'A simple narrative technique invented by García Márquez',
      'A worldview that blends ordinary and extraordinary as complementary realities',
      'A style that focuses only on supernatural elements',
      'A purely Colombian literary movement'
    ],
    correcta: 1
  },
  {
    id: 'w1', habilidad: 'writing', nivel: 'A1',
    tipo: 'completar',
    instruccion: 'Complete the sentence with the correct word.',
    pregunta: 'Me ___ María y tengo veinte años.',
    opciones: ['llamas', 'llamo', 'llama', 'llamamos'],
    correcta: 1
  },
  {
    id: 'w2', habilidad: 'writing', nivel: 'A2',
    tipo: 'completar',
    instruccion: 'Choose the correct option to complete the sentence.',
    pregunta: 'Ayer ___ al cine con mis amigos y vimos una película muy buena.',
    opciones: ['voy', 'iba', 'fui', 'iré'],
    correcta: 2
  },
  {
    id: 'w3', habilidad: 'writing', nivel: 'B1',
    tipo: 'completar',
    instruccion: 'Select the correct verb form.',
    pregunta: 'Si tuviera más tiempo, ___ aprender a tocar la guitarra.',
    opciones: ['quiero', 'querría', 'quería', 'querré'],
    correcta: 1
  },
  {
    id: 'w4', habilidad: 'writing', nivel: 'B2',
    tipo: 'texto_libre',
    instruccion: 'Write 2-3 sentences in Spanish describing your daily routine. Use at least one reflexive verb.',
    pregunta: 'Describe your daily routine in Spanish:',
    minPalabras: 15
  },
  {
    id: 'w5', habilidad: 'writing', nivel: 'C1',
    tipo: 'texto_libre',
    instruccion: 'Write a short paragraph in Spanish (4-5 sentences) giving your opinion about the importance of learning languages.',
    pregunta: 'Give your opinion about learning languages:',
    minPalabras: 30
  },
  {
    id: 's1', habilidad: 'speaking', nivel: 'A1',
    tipo: 'pronunciacion',
    instruccion: 'Read this sentence aloud in Spanish. Click the speaker to hear the correct pronunciation first.',
    audio_texto: 'Buenos días, me llamo Carlos y soy de México.',
    pregunta: 'Read aloud: Buenos días, me llamo Carlos y soy de México.',
    pista: 'Focus on: bWEH-nos DEE-as, meh YA-mo KAR-los',
    duracionMinima: 4
  },
  {
    id: 's2', habilidad: 'speaking', nivel: 'A2',
    tipo: 'pronunciacion',
    instruccion: 'Listen to the example and practice saying this phrase.',
    audio_texto: 'Me gustaría reservar una habitación para dos noches, por favor.',
    pregunta: 'Read aloud: Me gustaría reservar una habitación para dos noches, por favor.',
    pista: 'Focus on: gus-ta-REE-a, ha-bi-ta-SYON',
    duracionMinima: 6
  },
  {
    id: 's3', habilidad: 'speaking', nivel: 'B1',
    tipo: 'respuesta_oral',
    instruccion: 'Answer this question in Spanish with at least 2 sentences.',
    audio_texto: 'Describe tu ciudad favorita y explica por qué te gusta.',
    pregunta: 'Describe your favorite city in Spanish.',
    pista: 'Include: location, what you like about it, activities you can do there',
    duracionMinima: 12
  },
  {
    id: 's4', habilidad: 'speaking', nivel: 'B2',
    tipo: 'respuesta_oral',
    instruccion: 'Give your opinion on this topic in Spanish (3-4 sentences).',
    audio_texto: 'Habla sobre las ventajas y desventajas de las redes sociales en la sociedad moderna.',
    pregunta: 'Talk about social media advantages and disadvantages in Spanish.',
    pista: 'Use: por un lado... por otro lado... en mi opinión...',
    duracionMinima: 18
  },
  {
    id: 's5', habilidad: 'speaking', nivel: 'C1',
    tipo: 'respuesta_oral',
    instruccion: 'Discuss this complex topic in Spanish for 30-60 seconds.',
    audio_texto: 'Analiza el impacto de la inteligencia artificial en el mercado laboral del futuro.',
    pregunta: 'Analyze the impact of AI on future job markets in Spanish.',
    pista: 'Use complex structures: subjunctive, conditionals, passive voice',
    duracionMinima: 25
  }
]

function getNivel(puntaje) {
  if (puntaje >= 90) return 'C2'
  if (puntaje >= 75) return 'C1'
  if (puntaje >= 60) return 'B2'
  if (puntaje >= 45) return 'B1'
  if (puntaje >= 25) return 'A2'
  // ANTES cualquier puntaje bajo caia en 'A1', incluso alguien que no
  // entendia nada de español. Ahora, por debajo de 10%, lo ubicamos en el
  // Nivel 0 "Primeros pasos" (alfabeto, sonidos, numeros, palabras basicas
  // de la plataforma) en vez de arrancarlo directo en contenido de A1 que
  // ya asume que sabe leer y pronunciar español.
  if (puntaje >= 10) return 'A1'
  return 'A0'
}

function getPuntajePorHabilidad(respuestas, habilidad) {
  const pregsHab = PREGUNTAS.filter(p => p.habilidad === habilidad)
  let correctas = 0
  pregsHab.forEach(p => {
    const r = respuestas[p.id]
    if (p.tipo === 'audio_opcion' || p.tipo === 'texto_opcion' || p.tipo === 'completar') {
      if (r === p.correcta) correctas++
    } else if (p.tipo === 'texto_libre') {
      if (r && r.trim().split(/\s+/).filter(Boolean).length >= (p.minPalabras || 5)) correctas++
    } else if (p.tipo === 'pronunciacion' || p.tipo === 'respuesta_oral') {
      // Estas preguntas ya no se autocalifican por contenido -- ahora se
      // graba la voz de verdad (ver GrabadorSpeaking abajo) y un profesor
      // certificado revisa el audio despues de que el estudiante se
      // registra (igual que en EnglishBridge). Aqui solo usamos la
      // duracion grabada como referencia visual de "completo".
      if (r?.duracion >= (p.duracionMinima || 5)) correctas++
    }
  })
  return Math.round((correctas / pregsHab.length) * 100)
}

const COLORES_NIVEL = {
  A0:'#6B7280', A1:'#22C55E', A2:'#3B82F6', B1:'#8B5CF6', B2:'#F59E0B', C1:'#EF4444', C2:'#1B3A8C'
}
const HABILIDADES_INFO = {
  listening: { ic:'🎧', label:'Listening', color:'#3B82F6', autoCalificado: true  },
  reading:   { ic:'📖', label:'Reading',   color:'#22C55E', autoCalificado: true  },
  writing:   { ic:'✍️', label:'Writing',   color:'#7C3AED', autoCalificado: false },
  speaking:  { ic:'🎤', label:'Speaking',  color:'#EF4444', autoCalificado: false },
}

// ── Grabador de voz para las preguntas de Speaking ─────────────────────
// Antes esto era un cuadro de texto que decia "en la plataforma completa
// podras grabar tu voz" -- no grababa nada de verdad, asi que cualquier
// respuesta (o ninguna con solo un par de palabras) pasaba el examen sin
// que nadie evaluara si el estudiante realmente sabe hablar. Ahora se
// graba con el microfono de verdad y, tras registrarse, un profesor
// certificado escucha el audio y confirma el nivel real (igual que en
// EnglishBridge). El texto de la pregunta, el audio de referencia y la
// pista ya se muestran arriba en la plantilla de la pregunta -- este
// componente solo se encarga de la grabacion.
function GrabadorSpeaking({ duracionMinima, onGrabacionLista }) {
  const [fase,     setFase]     = useState('lista')
  const [segundos, setSegundos] = useState(0)
  const [audioUrl, setAudioUrl] = useState(null)
  const [errorMic, setErrorMic] = useState('')

  const mediaRecorderRef = useRef(null)
  const chunksRef        = useRef([])
  const blobRef          = useRef(null)
  const intervalRef      = useRef(null)
  const DURACION_MAX     = 90

  useEffect(() => () => clearInterval(intervalRef.current), [])

  function iniciarPreparacion() {
    setFase('preparando')
    setSegundos(10)
    intervalRef.current = setInterval(() => {
      setSegundos(s => {
        if (s <= 1) { clearInterval(intervalRef.current); iniciarGrabacion(); return 0 }
        return s - 1
      })
    }, 1000)
  }

  async function iniciarGrabacion() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      const mr = new MediaRecorder(stream)
      chunksRef.current = []
      mr.ondataavailable = e => chunksRef.current.push(e.data)
      mr.onstop = () => {
        const blob = new Blob(chunksRef.current, { type: 'audio/webm' })
        blobRef.current = blob
        setAudioUrl(URL.createObjectURL(blob))
        stream.getTracks().forEach(t => t.stop())
      }
      mr.start()
      mediaRecorderRef.current = mr
      setFase('grabando')
      setSegundos(0)
      intervalRef.current = setInterval(() => {
        setSegundos(s => {
          if (s + 1 >= DURACION_MAX) { detenerGrabacion(); return DURACION_MAX }
          return s + 1
        })
      }, 1000)
    } catch (err) {
      setErrorMic('No se pudo acceder al microfono. Revisa los permisos del navegador.')
      setFase('lista')
    }
  }

  function detenerGrabacion() {
    clearInterval(intervalRef.current)
    mediaRecorderRef.current?.stop()
    setFase('listo')
  }

  function regrabar() {
    setAudioUrl(null)
    setSegundos(0)
    setFase('lista')
  }

  function confirmar() {
    onGrabacionLista({ duracion: segundos, audioUrl, blob: blobRef.current })
  }

  const suficiente = segundos >= duracionMinima

  return (
    <div>
      {errorMic && (
        <div style={{ background:'rgba(239,68,68,0.15)', border:'1px solid rgba(239,68,68,0.4)', borderRadius:10, padding:'10px 14px', fontSize:13, marginBottom:16, color:'#FCA5A5' }}>
          {errorMic}
        </div>
      )}

      {fase === 'lista' && (
        <div style={{ textAlign:'center', padding:'16px 0' }}>
          <p style={{ fontSize:12, opacity:.7, marginBottom:16 }}>
            Tendras 10 segundos para prepararte, luego se grabara tu respuesta (minimo {duracionMinima}s, maximo {DURACION_MAX}s).
          </p>
          <button onClick={iniciarPreparacion} type="button"
            style={{ background:'#EF4444', color:'#fff', border:'none', borderRadius:12, padding:'14px 32px', fontFamily:'inherit', fontSize:15, fontWeight:700, cursor:'pointer' }}>
            🎙 Empezar
          </button>
        </div>
      )}

      {fase === 'preparando' && (
        <div style={{ textAlign:'center', padding:'16px 0' }}>
          <div style={{ fontSize:13, opacity:.7, marginBottom:10 }}>Prepara tu respuesta...</div>
          <div style={{ fontSize:44, fontWeight:900, color:'#FCA5A5' }}>{segundos}</div>
        </div>
      )}

      {fase === 'grabando' && (
        <div style={{ textAlign:'center', padding:'16px 0' }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:10, marginBottom:14 }}>
            <div style={{ width:12, height:12, borderRadius:'50%', background:'#EF4444', animation:'pulseGrabEsp 1s infinite' }} />
            <span style={{ fontSize:13, fontWeight:700 }}>Grabando...</span>
          </div>
          <style>{`@keyframes pulseGrabEsp { 0%,100% { opacity:1; } 50% { opacity:.3; } }`}</style>
          <div style={{ fontSize:34, fontWeight:900, marginBottom:16 }}>{segundos}s</div>
          <button onClick={detenerGrabacion} type="button"
            style={{ background:'rgba(255,255,255,0.15)', color:'#fff', border:'none', borderRadius:12, padding:'12px 28px', fontFamily:'inherit', fontSize:14, fontWeight:700, cursor:'pointer' }}>
            ⏹ Detener
          </button>
        </div>
      )}

      {fase === 'listo' && (
        <div style={{ textAlign:'center', padding:'10px 0' }}>
          <div style={{ fontSize:13, marginBottom:10, color: suficiente ? '#86EFAC' : '#FCA5A5' }}>
            {suficiente ? '✅ Duracion suficiente' : `⚠ Muy corta, minimo ${duracionMinima}s (grabaste ${segundos}s)`}
          </div>
          <audio controls src={audioUrl} style={{ width:'100%', maxWidth:340, marginBottom:16 }} />
          <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
            <button onClick={regrabar} type="button"
              style={{ background:'rgba(255,255,255,0.1)', color:'#fff', border:'1px solid rgba(255,255,255,0.3)', borderRadius:10, padding:'10px 20px', fontFamily:'inherit', fontSize:13, fontWeight:600, cursor:'pointer' }}>
              🔄 Grabar de nuevo
            </button>
            <button onClick={confirmar} disabled={!suficiente} type="button"
              style={{ background: suficiente ? '#22C55E' : 'rgba(255,255,255,0.15)', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:13, fontWeight:700, cursor: suficiente ? 'pointer' : 'not-allowed' }}>
              ✅ Usar esta grabacion
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default function ExamenNivel({ onTerminar, onSaltar, onVolver }) {
  const [paso,       setPaso]       = useState('intro')
  const [pregActual, setPregActual] = useState(0)
  const [respuestas, setRespuestas] = useState({})
  const [textoLibre, setTextoLibre] = useState('')
  const [resultado,  setResultado]  = useState(null)
  const [cargando,   setCargando]   = useState(false)

  useEffect(() => { precargarMapaAudios() }, [])

  const pregunta = PREGUNTAS[pregActual]
  const habilidadActual = pregunta?.habilidad
  const progreso = Math.round((pregActual / PREGUNTAS.length) * 100)

  function responder(valor) {
    setRespuestas(prev => ({ ...prev, [pregunta.id]: valor }))
  }

  function siguiente() {
    if (pregunta.tipo === 'texto_libre') {
      responder(textoLibre)
      setTextoLibre('')
    }
    if (pregActual < PREGUNTAS.length - 1) {
      setPregActual(i => i + 1)
    } else {
      calcularResultado()
    }
  }

  function anterior() {
    if (pregActual > 0) {
      setPregActual(i => i - 1)
      setTextoLibre('')
    } else {
      setPaso('intro')
    }
  }

  async function calcularResultado() {
    setCargando(true)
    const pL = getPuntajePorHabilidad(respuestas, 'listening')
    const pR = getPuntajePorHabilidad(respuestas, 'reading')
    const pW = getPuntajePorHabilidad(respuestas, 'writing')
    const pS = getPuntajePorHabilidad(respuestas, 'speaking')
    const pTotal = Math.round((pL + pR + pW + pS) / 4)

    const res = {
      puntaje_listening: pL,
      puntaje_reading:   pR,
      puntaje_writing:   pW,
      puntaje_speaking:  pS,
      puntaje_total:     pTotal,
      nivel_listening:   getNivel(pL),
      nivel_reading:     getNivel(pR),
      nivel_writing:     getNivel(pW),
      nivel_speaking:    getNivel(pS),
      nivel_general:     getNivel(pTotal),
      completado:        true
    }

    try {
      await axios.post(API + '/curriculo/examen/guardar', res)
    } catch (err) { console.error(err) }

    // Recopilamos la escritura y las grabaciones de voz para enviarlas a
    // revision docente despues del registro (no se pueden calificar con
    // precision real sin que un profesor certificado las escuche, igual
    // que en EnglishBridge). Esto viaja hacia App.js -> Login.jsx via
    // onTerminar() y se envia por correo/queda en la cola de admin solo
    // cuando el estudiante se registra.
    const escritura = PREGUNTAS
      .filter(p => p.habilidad === 'writing' && p.tipo === 'texto_libre')
      .map(p => ({ pregunta: p.pregunta, nivel: p.nivel, texto: respuestas[p.id] || '' }))

    const grabaciones = PREGUNTAS
      .filter(p => p.habilidad === 'speaking')
      .map(p => ({
        pregunta_id: p.id,
        nivel: p.nivel,
        tema: p.pregunta,
        duracion: respuestas[p.id]?.duracion || 0,
        blob: respuestas[p.id]?.blob || null
      }))

    window.__examenDatosParaRevision = { escritura, grabaciones }

    setResultado(res)
    setPaso('resultado')
    setCargando(false)
  }

  function puedeAvanzar() {
    if (!pregunta) return false
    if (pregunta.tipo === 'audio_opcion' || pregunta.tipo === 'texto_opcion' || pregunta.tipo === 'completar') {
      return respuestas[pregunta.id] !== undefined
    }
    if (pregunta.tipo === 'texto_libre') {
      return textoLibre.trim().split(/\s+/).filter(Boolean).length >= (pregunta.minPalabras || 5)
    }
    if (pregunta.tipo === 'pronunciacion' || pregunta.tipo === 'respuesta_oral') {
      return respuestas[pregunta.id]?.duracion >= (pregunta.duracionMinima || 5)
    }
    return false
  }

  if (paso === 'intro') return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(145deg,#0a1628,#0f2347,#1a1248)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'system-ui, sans-serif', padding:20, position:'relative' }}>
      {onVolver && (
        <button onClick={onVolver}
          style={{ position:'absolute', top:24, left:24, background:'none', border:'none', cursor:'pointer', fontSize:14, color:'rgba(255,255,255,0.6)', fontFamily:'inherit', display:'flex', alignItems:'center', gap:6 }}>
          ← Back
        </button>
      )}
      <div style={{ background:'rgba(255,255,255,0.05)', backdropFilter:'blur(20px)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:24, padding:48, maxWidth:600, width:'100%', textAlign:'center', color:'#fff' }}>
        <div style={{ fontSize:64, marginBottom:16 }}>🎯</div>
        <h1 style={{ fontSize:28, fontWeight:900, marginBottom:8 }}>Spanish Level Test</h1>
        <p style={{ fontSize:16, opacity:.8, marginBottom:32, lineHeight:1.6 }}>
          Find out your Spanish level in 20 questions. We will evaluate your Listening, Reading, Writing and Speaking skills.
        </p>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:12, marginBottom:32 }}>
          {Object.entries(HABILIDADES_INFO).map(([key, info]) => (
            <div key={key} style={{ background:'rgba(255,255,255,0.08)', borderRadius:12, padding:'14px 16px', display:'flex', alignItems:'center', gap:10 }}>
              <span style={{ fontSize:24 }}>{info.ic}</span>
              <div>
                <div style={{ fontSize:14, fontWeight:700 }}>{info.label}</div>
                <div style={{ fontSize:11, opacity:.6 }}>5 questions</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:12, background:'rgba(255,255,255,0.08)', borderRadius:12, padding:'12px 16px', marginBottom:28, textAlign:'left' }}>
          <span style={{ fontSize:20 }}>⏱</span>
          <div style={{ fontSize:13, opacity:.8 }}>Estimated time: 10-15 minutes · You can skip at any time</div>
        </div>
        <button onClick={() => setPaso('examen')}
          style={{ width:'100%', padding:'14px', background:'linear-gradient(135deg,#7C3AED,#4F46E5)', color:'#fff', border:'none', borderRadius:12, fontFamily:'inherit', fontSize:16, fontWeight:800, cursor:'pointer', marginBottom:12 }}>
          Start Level Test
        </button>
        <button onClick={onSaltar}
          style={{ width:'100%', padding:'12px', background:'none', color:'rgba(255,255,255,0.5)', border:'none', fontFamily:'inherit', fontSize:14, cursor:'pointer', textDecoration:'underline' }}>
          Skip test, choose plan directly
        </button>
      </div>
    </div>
  )

  if (cargando) return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(145deg,#0a1628,#0f2347)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'system-ui, sans-serif' }}>
      <div style={{ textAlign:'center', color:'#fff' }}>
        <div style={{ fontSize:64, marginBottom:16 }}>🔍</div>
        <h2 style={{ fontSize:22, fontWeight:800, marginBottom:8 }}>Analyzing your results...</h2>
        <p style={{ opacity:.6 }}>We are calculating your Spanish level</p>
      </div>
    </div>
  )

  if (paso === 'resultado' && resultado) {
    const nivelGeneral = resultado.nivel_general
    return (
      <div style={{ minHeight:'100vh', background:'linear-gradient(145deg,#0a1628,#0f2347,#1a1248)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'system-ui, sans-serif', padding:20 }}>
        <div style={{ maxWidth:640, width:'100%' }}>
          <div style={{ background:'linear-gradient(135deg,' + COLORES_NIVEL[nivelGeneral] + 'dd,' + COLORES_NIVEL[nivelGeneral] + ')', borderRadius:20, padding:32, color:'#fff', textAlign:'center', marginBottom:20 }}>
            <div style={{ fontSize:64, marginBottom:8 }}>🎉</div>
            <h1 style={{ fontSize:28, fontWeight:900, marginBottom:4 }}>Your Spanish Level</h1>
            <div style={{ fontSize:72, fontWeight:900, marginBottom:4 }}>{nivelGeneral}</div>
            <div style={{ fontSize:16, opacity:.85 }}>Overall Score: {resultado.puntaje_total}%</div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:12, marginBottom:20 }}>
            {Object.entries(HABILIDADES_INFO).map(([key, info]) => {
              const puntaje = resultado['puntaje_' + key]
              const nivel = resultado['nivel_' + key]
              return (
                <div key={key} style={{ background:'rgba(255,255,255,0.08)', backdropFilter:'blur(10px)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:14, padding:20, color:'#fff' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:12 }}>
                    <span style={{ fontSize:22 }}>{info.ic}</span>
                    <span style={{ fontSize:14, fontWeight:700 }}>{info.label}</span>
                  </div>
                  <div style={{ fontSize:36, fontWeight:900, color: COLORES_NIVEL[nivel], marginBottom:4 }}>{nivel}</div>
                  <div style={{ height:6, background:'rgba(255,255,255,0.15)', borderRadius:999, overflow:'hidden', marginBottom:6 }}>
                    <div style={{ width: puntaje + '%', height:'100%', background: COLORES_NIVEL[nivel], borderRadius:999 }} />
                  </div>
                  <div style={{ fontSize:11, fontWeight:700, color: info.autoCalificado ? '#86EFAC' : '#FCD34D' }}>
                    {info.autoCalificado ? '✅ Confirmed' : '⏳ Estimated — pending review'}
                  </div>
                </div>
              )
            })}
          </div>

          <div style={{ background:'rgba(212,175,55,0.1)', border:'1px solid rgba(212,175,55,0.35)', borderRadius:14, padding:18, color:'#fff', marginBottom:20, display:'flex', gap:12 }}>
            <span style={{ fontSize:22 }}>👨‍🏫</span>
            <p style={{ fontSize:13, opacity:.9, lineHeight:1.6, margin:0 }}>
              Your writing and your voice recordings will be reviewed by a certified teacher as soon as you create your account.
              You will receive your confirmed final Writing and Speaking level by email.
            </p>
          </div>

          <div style={{ background:'rgba(255,255,255,0.08)', backdropFilter:'blur(10px)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:14, padding:20, color:'#fff', marginBottom:20 }}>
            <h3 style={{ fontSize:15, fontWeight:800, marginBottom:12 }}>📋 Recommended plan based on your level</h3>
            {nivelGeneral === 'A0' ? (
              <p style={{ fontSize:13, opacity:.8, lineHeight:1.6 }}>
                No problem — everyone starts somewhere! We recommend the <strong>3-Day Free Trial</strong> with our <strong>Nivel 0: Primeros pasos</strong> track — the alphabet, sounds, numbers and the basic words you'll see throughout the app, before moving into A1.
              </p>
            ) : nivelGeneral === 'A1' || nivelGeneral === 'A2' ? (
              <p style={{ fontSize:13, opacity:.8, lineHeight:1.6 }}>
                We recommend starting with <strong>EspañolGo Plus</strong> — it covers A1-B1 content perfect for your current level.
              </p>
            ) : nivelGeneral === 'B1' || nivelGeneral === 'B2' ? (
              <p style={{ fontSize:13, opacity:.8, lineHeight:1.6 }}>
                We recommend <strong>EspañolGo Advanced</strong> — with A1-C1 content and private classes to accelerate your progress.
              </p>
            ) : (
              <p style={{ fontSize:13, opacity:.8, lineHeight:1.6 }}>
                We recommend <strong>EspañolGo Mastery</strong> — our VIP experience with a personal mentor to reach full fluency.
              </p>
            )}
          </div>
          <button onClick={() => onTerminar(resultado, window.__examenDatosParaRevision)}
            style={{ width:'100%', padding:'14px', background:'linear-gradient(135deg,#7C3AED,#4F46E5)', color:'#fff', border:'none', borderRadius:12, fontFamily:'inherit', fontSize:16, fontWeight:800, cursor:'pointer' }}>
            Continue to plans →
          </button>
        </div>
      </div>
    )
  }

  const habInfo = HABILIDADES_INFO[habilidadActual]
  const pregEnHabilidad = PREGUNTAS.filter(p => p.habilidad === habilidadActual).indexOf(pregunta) + 1

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(145deg,#0a1628,#0f2347,#1a1248)', fontFamily:'system-ui, sans-serif', padding:20 }}>
      <div style={{ maxWidth:680, margin:'0 auto' }}>
        <div style={{ marginBottom:16 }}>
          <button onClick={anterior}
            style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, color:'rgba(255,255,255,0.6)', fontFamily:'inherit', display:'flex', alignItems:'center', gap:6, padding:0 }}>
            ← {pregActual === 0 ? 'Back' : 'Previous question'}
          </button>
        </div>
        <div style={{ marginBottom:24 }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:8 }}>
            <div style={{ display:'flex', alignItems:'center', gap:8, color:'#fff' }}>
              <span style={{ fontSize:20 }}>{habInfo.ic}</span>
              <span style={{ fontSize:14, fontWeight:700 }}>{habInfo.label}</span>
              <span style={{ fontSize:12, opacity:.6 }}>Question {pregEnHabilidad}/5</span>
            </div>
            <span style={{ fontSize:12, color:'rgba(255,255,255,0.6)' }}>{pregActual + 1} of {PREGUNTAS.length}</span>
          </div>
          <div style={{ height:6, background:'rgba(255,255,255,0.15)', borderRadius:999, overflow:'hidden' }}>
            <div style={{ width: progreso + '%', height:'100%', background: habInfo.color, borderRadius:999, transition:'width .4s ease' }} />
          </div>
          <div style={{ display:'flex', gap:4, marginTop:8 }}>
            {['listening','reading','writing','speaking'].map(h => (
              <div key={h} style={{ flex:1, height:3, borderRadius:999,
                background: h === habilidadActual ? HABILIDADES_INFO[h].color :
                  PREGUNTAS.findIndex(p => p.habilidad === h) < pregActual ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.1)' }} />
            ))}
          </div>
        </div>

        <div style={{ background:'rgba(255,255,255,0.06)', backdropFilter:'blur(20px)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:20, padding:32, color:'#fff' }}>
          <div style={{ fontSize:12, opacity:.6, textTransform:'uppercase', letterSpacing:1, marginBottom:8 }}>
            {habInfo.label} · Level {pregunta.nivel}
          </div>
          <p style={{ fontSize:14, opacity:.8, marginBottom:20, lineHeight:1.6, fontStyle:'italic' }}>
            {pregunta.instruccion}
          </p>

          {pregunta.audio_texto && (
            <div style={{ background:'rgba(255,255,255,0.08)', borderRadius:12, padding:16, marginBottom:20 }}>
              <div style={{ display:'flex', alignItems:'flex-start', gap:12 }}>
                <button onClick={() => hablar(pregunta.audio_texto)}
                  style={{ background: habInfo.color, border:'none', borderRadius:10, width:40, height:40, cursor:'pointer', fontSize:18, flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center' }}>
                  🔊
                </button>
                <p style={{ fontSize:14, lineHeight:1.7, opacity:.9, margin:0 }}>{pregunta.audio_texto}</p>
              </div>
            </div>
          )}

          {pregunta.texto && (
            <div style={{ background:'rgba(255,255,255,0.08)', borderRadius:12, padding:16, marginBottom:20 }}>
              <p style={{ fontSize:14, lineHeight:1.8, opacity:.9, margin:0 }}>{pregunta.texto}</p>
            </div>
          )}

          <h2 style={{ fontSize:17, fontWeight:700, marginBottom:20, lineHeight:1.5 }}>{pregunta.pregunta}</h2>

          {(pregunta.tipo === 'audio_opcion' || pregunta.tipo === 'texto_opcion' || pregunta.tipo === 'completar') && (
            <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
              {pregunta.opciones.map((op, i) => {
                const seleccionada = respuestas[pregunta.id] === i
                return (
                  <button key={i} onClick={() => responder(i)}
                    style={{ padding:'13px 18px', border:'1.5px solid ' + (seleccionada ? habInfo.color : 'rgba(255,255,255,0.2)'),
                      borderRadius:10, background: seleccionada ? habInfo.color + '33' : 'rgba(255,255,255,0.04)',
                      color:'#fff', fontFamily:'inherit', fontSize:14, cursor:'pointer', textAlign:'left',
                      display:'flex', alignItems:'center', gap:12, transition:'all .15s' }}>
                    <span style={{ width:28, height:28, borderRadius:'50%', background: seleccionada ? habInfo.color : 'rgba(255,255,255,0.15)',
                      display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:800, flexShrink:0 }}>
                      {String.fromCharCode(65 + i)}
                    </span>
                    {op}
                  </button>
                )
              })}
            </div>
          )}

          {pregunta.tipo === 'texto_libre' && (
            <div>
              <textarea value={textoLibre} onChange={e => setTextoLibre(e.target.value)}
                placeholder="Write your answer in Spanish here..."
                style={{ width:'100%', minHeight:120, padding:'12px 14px', border:'1.5px solid rgba(255,255,255,0.2)', borderRadius:10, fontFamily:'inherit', fontSize:14, outline:'none', resize:'vertical', lineHeight:1.6, boxSizing:'border-box', background:'rgba(255,255,255,0.08)', color:'#fff' }}
              />
              <div style={{ fontSize:12, opacity:.6, marginTop:6 }}>
                {textoLibre.trim().split(/\s+/).filter(Boolean).length} / {pregunta.minPalabras} words minimum
              </div>
            </div>
          )}

          {(pregunta.tipo === 'pronunciacion' || pregunta.tipo === 'respuesta_oral') && (
            <div>
              {pregunta.pista && (
                <div style={{ background:'rgba(255,255,255,0.08)', borderRadius:10, padding:'10px 14px', marginBottom:14, fontSize:12, opacity:.7 }}>
                  💡 {pregunta.pista}
                </div>
              )}
              <GrabadorSpeaking
                key={pregunta.id}
                duracionMinima={pregunta.duracionMinima}
                onGrabacionLista={datos => responder(datos)}
              />
            </div>
          )}

          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:24 }}>
            <button onClick={onSaltar}
              style={{ background:'none', border:'none', color:'rgba(255,255,255,0.4)', fontSize:12, cursor:'pointer', fontFamily:'inherit' }}>
              Skip test
            </button>
            <button onClick={siguiente} disabled={!puedeAvanzar()}
              style={{ padding:'11px 28px', background: puedeAvanzar() ? habInfo.color : 'rgba(255,255,255,0.15)',
                color: puedeAvanzar() ? '#fff' : 'rgba(255,255,255,0.4)',
                border:'none', borderRadius:10, fontFamily:'inherit', fontSize:14, fontWeight:700,
                cursor: puedeAvanzar() ? 'pointer' : 'not-allowed', transition:'all .15s' }}>
              {pregActual < PREGUNTAS.length - 1 ? 'Next' : 'See my results'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
